var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentAmountCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 5.30469H4.8C3.801 5.30469 3.009 6.08344 3.009 7.05469L3 17.5547C3 18.5259 3.801 19.3047 4.8 19.3047H19.2C20.199 19.3047 21 18.5259 21 17.5547V7.05469C21 6.08344 20.199 5.30469 19.2 5.30469ZM19.2 17.5547H4.8V12.3047H19.2V17.5547ZM19.2 8.80469H4.8V7.05469H19.2V8.80469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAmountCard);
export default __webpack_public_path__ + "static/media/payment_amount_card.08b459f58c62f0215a7fa74914fbb19d.svg";
export { ForwardRef as ReactComponent };